import { render, staticRenderFns } from "./CrearCita.vue?vue&type=template&id=1f2be116&scoped=true"
import script from "./CrearCita.vue?vue&type=script&lang=js"
export * from "./CrearCita.vue?vue&type=script&lang=js"
import style0 from "./CrearCita.vue?vue&type=style&index=0&id=1f2be116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2be116",
  null
  
)

export default component.exports